import * as units from '../utils/units.js'

export default class BoltAndNut {
  // bolt and nut
  boltType = 'threaded-rod'
  nutType = 'Square'
  boltDiameterLabel = '1/2"'
  boltDiameter = 0.5 // in
  embedDepth = 6 // in
  tensileStrength = 58 // ksi
  hookLength = 3 //in
  groutPads = false
  weldedToBasePlate = false
  dirty = false
  
  deserialize(json) {
    Object.assign(this, json)
    this.dirty = false
  }

  serialize() {
    const d = {}
    Object.keys(this).forEach( (key) => d[key] = this[key] )
    return d
  }
  
  onUpdate(detail) {
    Object.assign(this, detail)
    this.boltDiameter = detail.anchorProperties.Diameter
    this.embedDepth = units.parseLength(detail.embedDepth)
    this.hookLength = units.parseLength(detail.hookLength)
    this.tensileStrength = units.parsePressure(detail.tensileStrength)
    this.publishUpdate()
  }

  publishUpdate() {
    this.dirty = true
    let event = new CustomEvent('anchor-model-update', { detail: this });
    document.dispatchEvent(event)
    // update our button
    event = new CustomEvent('bolt-and-nut-model-update', { detail: {boltAndNut: this} });
    document.dispatchEvent(event)
  }

  get boltTypeStr() {
    return this.boltType.replace('-', ' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase())
  }

  get nutStudOrHookStr() {
    if(this.boltType === 'threaded-rod' || this.boltType === 'headed-bolt') {
      return `${this.nutType} Nut`
    }
    if(this.boltType === 'headed-stud') {
      return 'No nuts'
    }
    return `${this.hookLength} in hook`
  }

  get hasNuts() {
    return (this.boltType === 'threaded-rod' || this.boltType === 'headed-bolt') 
  }
}